import { Loader } from '../Widgets';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Party, Transaction } from 'service';
import ArthaGateway from 'service/ArthaGateway';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { durations } from 'service/Utils';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons';

export const Ledger = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [party, setParty] = useState<Party>();
    const [durationId, setDurationId] = useState<string>(moment().month() > 3 ? moment().year().toString() : moment().subtract(1, 'year').year().toString());
    const [transactions, setTransactions] = useState<Transaction[]>([]);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (user.profile) {
            setParty(user.profile.profile);
        }
    }, [user]);

    useEffect(() => {
        if (!party) {
            return;
        }
        setIsLoading(true);
        ArthaGateway
            .getTransactions(party.accountId, durationId, pageNumber)
            .then((data) => {
                setTransactions(transactions.concat(data.entries));
                setTotalPages(data.totalPages);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });

        ArthaGateway
            .logActivity({
                partyId: party.partyId,
                activity: "View account statement",
                performedAt: moment().format("YYYY-MM-DD HH:mm:ss")
            });
    }, [party, durationId, pageNumber]);

    const currencyFormat = (value) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(value);

    const reloadData = (e) => {
        setTransactions([]);
        setDurationId(e.target.value)
    };

    const downloadStatement = () => {
        ArthaGateway
            .getPartyStatementFileLink(party?.accountId, durationId)
            .then((url) => {
                window.open(url, "_blank");
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    return (
        <>
            {isLoading &&
                <Loader />
            }
            {!isLoading && (
                <div className="page page-ledger">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card bg-dark text-white mb-2'>
                                <div className='card-header'>
                                    <h2>Account Statement</h2>
                                    <div>
                                        <select className="form-control" id="duration" value={durationId} onChange={reloadData}>
                                            {durations.map((duration) => (
                                                <option key={duration.value} value={duration.value}>{duration.label}</option>
                                            ))}
                                            <option value="-1">Other</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card-body p-0'>
                                {(transactions.length === 0) &&
                                    <div className="p-2">
                                        <div className="alert alert-danger">No transactions during this period</div>
                                    </div>
                                }
                                <ul className="list-group list-group-flush">
                                    {(transactions.length > 0) &&
                                        <div className={`card ${transactions[0].closingBalance > 0 ? "bg-danger" : "bg-success"} text-white w-100 mb-2`}>
                                            <div className="text-center">
                                                <div>Closing Balance</div>
                                                {transactions[0].closingBalance > 0 &&
                                                    <h3 className='fw-bold'>{currencyFormat(transactions[0].closingBalance)}</h3>
                                                }
                                                {transactions[0].closingBalance <= 0 &&
                                                    <h3 className='fw-bold'>{currencyFormat(transactions[0].closingBalance)}</h3>
                                                }
                                            </div>
                                        </div>
                                    }
                                    {transactions && transactions.map((transaction) => (
                                        (transaction.credit > 0 || transaction.debit > 0) &&
                                        <li className="list-group-item py-0" key={transaction.id}>
                                            <div className="fw-bold">
                                                {moment(transaction.transactionDate).format("DD MMM YYYY")}
                                            </div>
                                            <div>{transaction.voucherType} - {transaction.voucherNumber}</div>
                                            <div className="desc">{transaction.description}</div>
                                            {transaction.debit > 0 &&
                                                <h3 className='text-danger float-end fw-bold'>{currencyFormat(transaction.debit)}</h3>
                                            }
                                            {transaction.credit > 0 &&
                                                <h3 className='text-success float-end fw-bold'>{currencyFormat(transaction.credit)}</h3>
                                            }
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className='card-footer'>
                                {(totalPages > pageNumber) &&
                                    <div className="btn btn-primary" onClick={() => setPageNumber(pageNumber + 1)}>Load More...</div>
                                }
                            </div>
                            <div className="card-footer">
                                <div className="btn btn-dark w-100" title="View" onClick={() => downloadStatement()}>
                                    <FontAwesomeIcon icon={faFileInvoice} style={{ width: "auto" }} />
                                    &nbsp; Download Statement
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-6">
                            <NavLink to="/" className="btn btn-danger w-100">
                                Back
                            </NavLink>
                        </div>
                    </div>
                </div >
            )}
        </>
    );
};